import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN } from 'constant';

const PublicRoute = () => {
  const token = Cookies.get(ACCESS_TOKEN);

  return token ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Outlet />;
};

export default PublicRoute;
